export type PublicLocale = "en" | "de"

export type AlternateLink = {
  locale?: string
  href_lang: string
  href: string
}

export function localePathsFrom(alternateLinks: AlternateLink[]): Partial<Record<PublicLocale, string>> {
  return alternateLinks.reduce<Partial<Record<PublicLocale, string>>>((paths, link) => {
    const locale = link.locale ?? link.href_lang
    if (locale === "en" || locale === "de") paths[locale] = pathFromHref(link.href)
    return paths
  }, {})
}

export function canonicalHref(alternateLinks: AlternateLink[], locale: PublicLocale) {
  return alternateLinks.find((link) => (link.locale ?? link.href_lang) === locale)?.href
}

export function publicMetaDescription(primary: string, extension: string) {
  const primaryText = normalizeWhitespace(primary)
  const combined = primaryText.length >= 120 ? primaryText : normalizeWhitespace(`${primaryText} ${extension}`)
  if (combined.length <= 160) return combined

  const candidate = combined.slice(0, 159)
  const lastWholeWord = candidate.lastIndexOf(" ")
  const truncated = (lastWholeWord >= 120 ? candidate.slice(0, lastWholeWord) : candidate).replace(/[,:;.!?\-–—]+$/, "")
  return `${truncated}…`
}

function pathFromHref(href: string) {
  try {
    const url = new URL(href)
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return href
  }
}

function normalizeWhitespace(value: string) {
  return value.trim().replace(/\s+/g, " ")
}
